import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";

export const passwordChecks = (value = "") => ({
  length: value.length >= 8,
  uppercase: /[A-Z]/.test(value),
  special: /[^A-Za-z0-9]/.test(value),
});

export function PasswordRules({ value, lang = "de" }) {
  const checks = passwordChecks(value);
  const labels = lang === "de"
    ? { length: "Mindestens 8 Zeichen", uppercase: "Mindestens 1 Großbuchstabe", special: "Mindestens 1 Sonderzeichen" }
    : { length: "At least 8 characters", uppercase: "At least 1 uppercase letter", special: "At least 1 special character" };
  return <ul className="mt-2 space-y-1 text-xs" aria-live="polite">
    {Object.entries(labels).map(([key, label]) => <li key={key} style={{ color: checks[key] ? "var(--pc-score-good)" : "var(--pc-muted)" }}>
      {checks[key] ? "✓" : "○"} {label}
    </li>)}
  </ul>;
}

export default function PasswordField({ value, onChange, inputRef, label, showRules = false, lang, className = "pc-input", ...props }) {
  const [visible, setVisible] = useState(false);
  const showLabel = lang === "de" ? "Passwort anzeigen" : "Show password";
  const hideLabel = lang === "de" ? "Passwort verbergen" : "Hide password";
  return <div>
    {label && <label className="text-sm" style={{ color: "var(--pc-muted)" }}>{label}</label>}
    <div className="relative">
      <input ref={inputRef} className={`${className}${label ? " mt-2" : ""} pr-11`} type={visible ? "text" : "password"} value={value} onChange={onChange} {...props} />
      <button type="button" onClick={() => setVisible((current) => !current)} aria-label={visible ? hideLabel : showLabel}
        className="absolute right-2 top-1/2 -translate-y-1/2 grid place-items-center p-2" style={{ color: "var(--pc-muted)", background: "transparent", border: 0 }}>
        {visible ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
    {showRules && <PasswordRules value={value} lang={lang} />}
  </div>;
}
